import React, { useCallback, useEffect, useReducer, useState } from "react";
import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import { add, getBannerDetail, getList, getListBannerGroup, update, updateDetail } from "./controller";
import AddPopup from "./partials/popups/AddPopup";
import ConfirmPopup from './partials/popups/ConfirmPopup';
import DetailPopup from "./partials/popups/DetailPopup";

export const Context = React.createContext(null);

const initialData = {
  listBannerGroup: [],
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  confirmPopup: {
    show: false,
    confirmed: false,
    id: undefined,
  },
  addPopup: {
    show: false,
    image: undefined,
    group: undefined,
    title: undefined,
    subTitle: undefined,
    subTitle2: undefined,
    confirmed: false,
  },
  detailPopup: {
    show: false,
    detail: undefined,
    id: undefined,
    confirmed: false,
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_BANNER_GROUP':
      return {
        ...state,
        listBannerGroup: action.payload
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'OPEN_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: true,
          confirmed: false,
          id: action.payload.id,
        }
      }
    case 'CLOSE_CONFIRM_POPUP':
      return {
        ...state,
        confirmPopup: {
          show: false,
          id: action.payload ? state.confirmPopup.id : undefined,
          confirmed: action.payload
        }
      }
    case 'OPEN_ADD_POPUP':
      return {
        ...state,
        addPopup: {
          show: true,
          confirmed: false,
        }
      }
    case 'CLOSE_ADD_POPUP':
      return {
        ...state,
        addPopup: {
          show: false,
          image: action.payload.confirmed ? action.payload.image : undefined,
          confirmed: action.payload.confirmed,
          group: action.payload.confirmed ? action.payload.group : undefined,
          title: action.payload.confirmed ? action.payload.title : undefined,
          subTitle: action.payload.confirmed ? action.payload.subTitle : undefined,
          subTitle2: action.payload.confirmed ? action.payload.subTitle2 : undefined,
        }
      }
    case 'OPEN_DETAIL_POPUP':
      return {
        ...state,
        detailPopup: {
          show: true,
          id: action.payload.id,
          confirmed: false,
        }
      }
    case 'GET_BANNER_DETAIL':
      return {
        ...state,
        detailPopup: {
          ...state.detailPopup,
          detail: action.payload,
        }
      }
    case 'CLOSE_DETAIL_POPUP':
      return {
        ...state,
        detailPopup: {
          show: false,
          id: action.payload.confirm ? state.detailPopup.id : undefined,
          detail: action.payload.confirm ? action.payload.detail : undefined,
          confirmed: action.payload.confirm
        }
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['wvivu'])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const getAllFunc = useCallback(async () => {
    setLoading(true)

    const response = await getList(cookies.wvivu)

    if (response) {
      setError(false)
      dispatch({
        type: 'UPDATE_DATA',
        payload: response
      })
    } else {
      setError(true)
    }
    setLoading(false)
  }, [
    cookies.wvivu,
  ])

  const getBannerGroupFunc = useCallback(async () => {

    const response = await getListBannerGroup(cookies.wvivu)

    if (response) {
      setError(false)
      dispatch({
        type: 'UPDATE_BANNER_GROUP',
        payload: response.list
      })
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
  ])

  const getBannerDetailFunc = useCallback(async () => {

    const response = await getBannerDetail(cookies.wvivu, state.detailPopup.id)

    if (response) {
      setError(false)
      dispatch({
        type: 'GET_BANNER_DETAIL',
        payload: response.detail
      })
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu, state.detailPopup.id
  ])

  useEffect(() => {
    if (state.detailPopup.id && state.detailPopup.show) {
      getBannerDetailFunc()
    }
  }, [state.detailPopup.show, state.detailPopup.id])

  useEffect(() => {
    getBannerGroupFunc()
    getAllFunc()
  }, [getAllFunc, getBannerGroupFunc])

  useEffect(() => {
    document.title = "Quảng cáo"
  }, []);

  const addFunc = useCallback(async (image, title, subTitle, subTitle2, group) => {
    const response = await add(cookies.wvivu, image, title, subTitle, subTitle2, group)

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    getAllFunc,
  ])

  const updateFunc = useCallback(async (id) => {

    const response = await update(cookies.wvivu, id, 'DELETE', undefined)

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    getAllFunc,
  ])

  const updateDetailFunc = useCallback(async () => {

    const response = await updateDetail(cookies.wvivu, state.detailPopup.id, 'UPDATE', state.detailPopup.detail)

    if (response) {
      setError(false)
      getAllFunc()
    } else {
      setError(true)
    }
  }, [
    cookies.wvivu,
    state.detailPopup.id,
    state.detailPopup.detail,
    getAllFunc,
  ])

  useEffect(() => {
    if (state.confirmPopup.confirmed && state.confirmPopup.id) {
      updateFunc(state.confirmPopup.id)
    }
  }, [updateFunc, state.confirmPopup.confirmed, state.confirmPopup.id])

  useEffect(() => {
    if (state.detailPopup.confirmed && state.detailPopup.id && state.detailPopup.detail) {
      updateDetailFunc()
    }
  }, [updateDetailFunc, state.detailPopup.confirmed, state.detailPopup.id, state.detailPopup.detail])

  useEffect(() => {
    if (state.addPopup.confirmed && state.addPopup.image) {
      addFunc(state.addPopup.image, state.addPopup.title, state.addPopup.subTitle, state.addPopup.subTitle2, state.addPopup.group)
    }
  }, [addFunc, state.addPopup.confirmed, state.addPopup.image, state.addPopup.title, state.addPopup.subTitle, state.addPopup.subTitle2, state.addPopup.group])

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      {loading ? 'Loading.....' : error ? 'Lỗi!?' : <Table />}

      <ConfirmPopup />
      <DetailPopup />
      <AddPopup />
    </Context.Provider>
  );
};
